import { Component } from '@angular/core';

import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-csv-tutorial',
  imports: [CommonModule],
  standalone: true,
  template: `
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div class="pb-4">
        <h2 class="text-xl font-semibold mb-4">How to Import Your CSV</h2>
        <p class="mt-2 text-sm text-gray-700">
          This is a click-through tutorial for importing data.
        </p>
      </div>

      <!-- Stepper -->
      <div class="relative">
        <ol
          class="flex flex-col items-center  space-y-6 md:space-y-0 md:flex-row md:items-start md:justify-between"
        >
          <li
            *ngFor="let step of steps; let i = index"
            class="relative flex flex-col md:flex-1 items-center text-center"
          >
            <!-- Line connector (desktop only) -->
            <div
              *ngIf="i < steps.length - 1"
              class="hidden md:block absolute top-5 left-1/2 w-full h-0.5 bg-gray-300 z-10"
              [ngStyle]="{ left: '50%', right: '-50%' }"
            ></div>

            <!-- Step circle -->
            <button
              (click)="activeStep = i"
              type="button"
              class="z-10  relative flex items-center justify-center size-10 rounded-full border-2 transition duration-200"
              [class.bg-columbus-blue-600]="activeStep === i"
              [class.bg-white]="activeStep != i"
              [class.border-columbus-blue-600]="activeStep === i"
              [class.border-gray-300]="activeStep !== i"
              [class.text-white]="activeStep === i"
              [class.text-gray-700]="activeStep !== i"
            >
              {{ i + 1 }}
            </button>

            <!-- Title: under circle (desktop), right of circle (mobile) -->
            <div
              class="mt-2 text-sm font-medium md:mt-2 text-columbus-blue-700 md:text-center md:w-full"
              [class.text-columbus-blue-700]="activeStep === i"
              [class.text-gray-700]="activeStep !== i"
            >
              <span class="hidden md:block">{{ step.title }}</span>
              <span class="md:hidden ml-3">{{ step.title }}</span>
            </div>
          </li>
        </ol>

        <!-- Shared Description Area -->
        <div
          class="mt-8 border border-gray-200 bg-white p-6 rounded-md shadow-sm transition-all duration-300"
        >
          <h3 class="text-lg font-semibold text-columbus-blue-700">
            {{ steps[activeStep].title }}
          </h3>
          <p class="mt-2 text-sm text-gray-700">
            {{ steps[activeStep].description }}
          </p>
        </div>
      </div>
    </div>
  `,
  styles: ``,
})
export class CsvTutorialComponent {
  activeStep = 0;

  steps = [
    {
      title: 'Input CSV',
      description: 'Upload a valid .csv file exported from your source system.',
    },
    {
      title: 'Check Errors',
      description: 'Review which rows couldn’t be imported and why.',
    },
    {
      title: 'Convert Data',
      description: 'Map your CSV columns into structured bookings data.',
    },
    {
      title: 'Validation',
      description: 'Check if Bookings are valid for import',
    },
    {
      title: 'Select Data',
      description: 'Choose valid rows to be imported into the system.',
    },
    {
      title: 'Import Data',
      description: 'Commit your selected rows to the booking system.',
    },
  ];
}
